import React from 'react';

import { LocationOn } from '@mui/icons-material';
import type { CardProps } from '@mui/material';
import { Button, Card, Stack, useTheme } from '@mui/material';
import { DEFAULT_LOCATION } from '../config';
import { toLatLng } from '../utils/libs';
import GoogleStaticMaps from './google_static_maps';
import type { MapsPickerResultType } from './maps_picker_dialog';
import { MapsPickerDialog } from './maps_picker_dialog';

const defaultAspectRatio = 2;

export type MapsPickerCardProps = {
  location?: { latitude: number; longitude: number };
  onConfirm?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>, result: MapsPickerResultType) => void;
  disabled?: boolean;
  buttonText?: string;
} & CardProps;

export const MapsPickerCard = ({ location, onConfirm, disabled, buttonText, sx, ...props }: MapsPickerCardProps) => {
  const theme = useTheme();

  const [openDialog, setOpenDialog] = React.useState(false);
  const currentMapCenter = toLatLng(location) ?? DEFAULT_LOCATION;

  return (
    <Card {...props} sx={{ width: '100%', aspectRatio: defaultAspectRatio, ...sx }}>
      <Stack width="100%" height="100%" position="relative">
        <GoogleStaticMaps
          center={currentMapCenter}
          zoom={location ? 15 : 12}
          imageSize={{ width: 600, height: 300 }}
          markers={location ? [{ location: currentMapCenter, size: 'mid' }] : undefined}
        />

        {disabled ? null : (
          <Stack
            width="100%"
            height="100%"
            position="absolute"
            justifyContent="flex-end"
            alignItems="center"
            gap={1}
            bgcolor="rgba(0,0,0,0.1)"
          >
            <Button
              id="google-maps-picker-button"
              variant="contained"
              color="inherit"
              size="large"
              disableElevation
              onClick={() => setOpenDialog(true)}
              startIcon={<LocationOn />}
              sx={{ minWidth: '40%', bottom: 32 }}
              style={{ backgroundColor: theme.palette.background.paper }}
            >
              {buttonText ?? 'เลือกสถานที่'}
            </Button>
          </Stack>
        )}
      </Stack>

      <MapsPickerDialog
        open={openDialog}
        initialMapCenter={location}
        onClose={() => setOpenDialog(false)}
        onConfirm={onConfirm}
      />
    </Card>
  );
};
